
import regExpressions from "@/shared/constants/regexpressions.js";

/// Generic validation rules
/// *************************************
const validationRules = function (args) {
  return {
    required: value => {
      if (typeof value === "boolean") return value !== undefined && value !== null; // Any value besides undefined and null is a valid boolean
      else if (typeof value === "string") return !!value.trim() || (args && args.reqFld) || false;
      else return !!value || (args && args.reqFld) || false;
    },
    // Empty values will not be evaluated to Error
    email: value => {
      regExpressions.Email.lastIndex = 0; // reset regEx manually
      return value == undefined || value == "" || regExpressions.Email.test(value) || (args && args.invEMail) || false;
    },
    ukMobile: value => {
      regExpressions.UKMobileNumber.lastIndex = 0; // reset regEx manually
      return value == undefined || value == "" || regExpressions.UKMobileNumber.test(value) || (args && args.invPhoneNumber) || false;
    },
    ukLandLine: value => {
      regExpressions.UKLandLineNumber.lastIndex = 0; // reset regEx manually
      return value == undefined || value == "" || regExpressions.UKLandLineNumber.test(value) || (args && args.invPhoneNumber) || false;
    },
    eirCode: value => {
      regExpressions.EirCode.lastIndex = 0; // reset regEx manually
      return (value == undefined || value == "") || regExpressions.EirCode.test(value) || (args && args.invEirCode) || false;
    },
    postCode: value => {
      regExpressions.PostCode.lastIndex = 0; // reset regEx manually
      return value == undefined || value == "" || regExpressions.PostCode.test(value) || (args && args.invPostCode) || false;
    },
    sortCode: value => {
      regExpressions.SortCode.lastIndex = 0; // reset regEx manually
      return value == undefined || value == "" || regExpressions.SortCode.test(value) || (args && args.invSortCode) || false;
    },
    fixedLength: (value, len) => { return value == undefined || value == "" || value.length === len || (args && args.invValue) || false; },
    numeric: value => { return value == undefined || value == "" || value.isNumeric() || (args && args.invValue) || false; },
    notZero: value => { return value == undefined || value == "" || (value.isNumeric() && value != 0) || (args && args.invValue) || false; },
    text: value => {
      regExpressions.GenericTexts.lastIndex = 0; // reset regEx manually
      const segments = regExpressions.GenericTexts.exec(value);
      return value == undefined || value == "" || (segments !== null && segments[0] === value) || (args && args.invChars) || false;
    },
    ppsn: value => { return value == undefined || value == "" || validatePPSNumber(value) || (args && args.invPPS) || false; },
    nin: value => { return value == undefined || value == "" || validateNINumber(value) || (args && args.invNIN) || false; },
    
  };
};

/// Validate PPS Number
/// ****************************************
const validatePPSNumber = function (value) {
  var ret = false;
  var formatRegex = /^(\d{7})([A-Z]{1,2})$/i;
  if (formatRegex.test(value)) {
    // Validate Check Digit
    var numericPart = value.substring(0, 7);
    var checksumCharacter = value.substring(7);
    var multiplyingFactor = 8;
    var sum = 0;
    for (var i = 0; i < numericPart.length; i++) {
      sum += numericPart[i] * multiplyingFactor--;
    }
    sum += RegExp.$2[1] ? (RegExp.$2[1].toUpperCase().charCodeAt(0) - 64) * 9 : 0;

    var checksum = sum % 23;
    ret = (checksum === 0 && checksumCharacter.toUpperCase()[0] === "W") || (checksum + 64 === checksumCharacter.toUpperCase().charCodeAt(0));
  }
  return ret;
};

/// Validate National Insurance Number
/// ***************************************
const validateNINumber = function (value) {
  var ret = false;
  var formatRegex = /^[A-CEGHJ-PR-TW-Z][A-CEGHJ-NPR-TW-Z] ?[0-9]{2} ?[0-9]{2} ?[0-9]{2} ?[ABCD]?$/i;
  if (formatRegex.test(value)) {
    formatRegex = /^(GB)|^(BG)|^(NK)|^(KN)|^(TN)|^(NT)|^(ZZ)/i; // Exceptions
    ret = !formatRegex.test(value);
  }
  return ret;
};

export default {
  validationRules, 
};